import React from 'react';

import { FormProvider } from 'react-hook-form';

import cs from '../../../../index.module.css';
import { useInfoWizardContext } from '../../context';
import { InfoButtonsGroup } from './InfoButtonsGroup';
import { InfoForm } from './InfoForm';
import { useInfoForm } from './useInfoForm';

const Info = () => {
  const { tripEvent, onSubmit } = useInfoWizardContext();
  const { methods, tripEventDeafultValuesController, ...rest } = useInfoForm();

  return (
    <FormProvider {...methods}>
      <div className={cs.form}>
        <InfoForm tripEvent={tripEvent} {...rest} />

        <InfoButtonsGroup
          tripEvent={tripEvent}
          onSubmit={onSubmit}
          tripEventDeafultValuesController={tripEventDeafultValuesController}
        />
      </div>
    </FormProvider>
  );
};

export { Info };
